import { gql } from '@apollo/client';

export const REMOVE_ADDRESS_ALERT = gql`
  mutation removeAddressAlert($input: RemoveAddressAlertInput!) {
    removeAddressAlert(input: $input) {
      errors
    }
  }
`

//Example input:
// {
//   "input": {
//     "addressAlertId": 4129,
//     "officerId": "3472"
//   }
// }

